import { Numeric5Icon } from './Numeric5Icon';

/**
 * author: GreenTurtwig
 * id EFB5FA9A-E828-4D71-A35F-011D873DE490
 * name numeric-5
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-5.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number5Icon = Numeric5Icon;
export default Number5Icon